import {
    AfterViewInit,
    Directive,
    ElementRef,
    inject,
    input,
    InputSignal, OnDestroy,
    output,
    OutputEmitterRef
} from "@angular/core";

export class ProtrusionSpec {
    protrusion: number;
    class: string;
}

@Directive({
    selector: "[woa-sticky]"
})
/**
 * Directive to add a class or classes to a sticky element as it approaches the edge of the viewport
 */
export class StickyDirective implements AfterViewInit, OnDestroy {
    private element: ElementRef = inject(ElementRef);

    public readonly topMargin: InputSignal<number> = input<number>(1);
    public readonly increments: InputSignal<number> = input<number>(10);
    public readonly classes: InputSignal<[ProtrusionSpec]> = input<[ProtrusionSpec]>([{protrusion: 0, class: "stuck"}]);
    public readonly minHeight: InputSignal<number> = input<number>(0);
    public readonly delay: InputSignal<number> = input<number>(0);

    public onStuckChange: OutputEmitterRef<boolean> = output<boolean>();

    private destroyed: boolean = false;

    ngAfterViewInit(): void {
        setTimeout(() => this.initHeight());
        setTimeout(() => new IntersectionObserver(
            ([entry]: [IntersectionObserverEntry]) => {
                if (this.destroyed) {
                    return;
                }
                const protrusion: number = entry.intersectionRect.top - entry.boundingClientRect.top;
                this.classes().forEach((spec: ProtrusionSpec) => entry.target.classList.toggle(spec.class, protrusion > spec.protrusion));
                this.onStuckChange.emit(protrusion > this.classes()[0].protrusion);
            },
            {
                rootMargin: "-" + this.topMargin() + "px 0px 0px 0px",
                threshold: Array.from({length: this.increments() + 1}, (_, i) => i / this.increments())
            }
        ).observe(this.element.nativeElement), this.delay());
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    private initHeight(): void {
        this.element.nativeElement.style.minHeight = Math.max(this.element.nativeElement.getBoundingClientRect().height, this.minHeight()) + "px";
        this.element.nativeElement.style.maxHeight = this.element.nativeElement.style.minHeight;
    }
}
